class FieldType {
    static LISTSELECTION = 'list-selection';
    static INDEX = 'index';

    static LABEL = 'label';                 //标签
    static LINK = 'link';                   //连接
    static DETAIL = 'detail';               //点击显示详情
    static HTMLDETAIL = 'html-detail';               //点击显示详情

    static IMAGE = 'image';                 //图片

    static BUTTON = 'button';               //按钮/按钮组

    static INPUT = 'input';                 //输入
    static INPUTSECTION = 'input-section';               
    static TEXTAREA = 'textarea';           //文本域
    static NUMBER = 'number';               //数字输入（*暂时不支持带单位）

    static CASCADE = 'cascade';             //级联
    static MCASCADE = 'multi-cascade';
    static TREE = 'tree';                   //树

    static RADIO = 'radio';                 //单选
    static CHECK = 'check';                 //复选
    static SELECT = 'select';               //下拉
    static MSELECT = 'multi-select';        //下拉多选
    static SELECTION = 'selection';         //查询单选
    static MSELECTION = 'multi-selection';  //查询多选
    static AUTOCOMPLETE = 'auto-complete';  //自动完成
    static TREESELECT = 'tree-select';      //下拉单选树
    static MTREESELECT = 'multi-tree-select';   //下拉多选树

    static DATE = 'date';                   //日期选择
    static TIME = 'time';                   //时间选择
    static DATETIME = 'date-time';          //日期+时间选择

    static DATERANGE = 'date-range';        //日期范围
    static DATETIMERANGE = 'date-time-range'//日期时间范围

    static SWITCH = 'switch';               //开关
    static COLOR = 'color';                 //颜色块
    static COLORPICKER = 'color-picker';    //颜色选择
    static TAG = 'tag';                     //标签
    static DTAG = 'dynamic-tag';            //动态标签

    static UPLOAD = 'upload';               //文件上传
    // static IMAGEUPLOAD = 'image-upload'     //图片上传

    static TAB = 'tab';                     //页签
    static STEP = 'step';                   //分步
    static TIMELINE = 'time-line';          //时间线（*暂时不支持）

    static PAGE = 'page';                   //页面模块

    static FORM = 'form';                   //嵌套表单
    static TABLE = 'table';                 //嵌套列表
    static SELECTIONS = 'selections'        //嵌套列表选择
    static FORMLIST = 'form-list';          //嵌套表单组

    static EUPLOAD = 'easy-upload';         //文件上传
    static IMAGEUPLOAD = 'image-upload';    //图片上传
    static RICHTEXT = 'rich-text';          //富文本

    static TITLE = 'title'

    static CUSTOM = 'custom';               //扩展|自定义
}

export default FieldType;